import axios from 'axios';

class LocalVideoUploadService {
    uploadFile(file) {
        const formData = new FormData();
        formData.append("file", file);

        return axios.post(`${process.env.REACT_APP_API_URL}/api/v3/videos/upload`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

     uploadFileWithPromise(file) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await this.uploadFile(file);
                console.log(response);
                resolve(response);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    }
}

const localVideoUploadServiceInstance = new LocalVideoUploadService();
export default localVideoUploadServiceInstance;